<template>
  <div
    class="mx-2 sm:mx-4 px-2 flex searchContainer rounded-lg cursor-text items-center text-gray-600"
    :class="[isOpen ? 'bg-gray-300 w-48' : 'bg-transparent w-10']"
    key="search"
  >
    <transition name="fade">
      <button class="flex select-none" @click.stop="searchIconClicked">
        <unicon
          name="search"
          class="justify-center block right-0 z-30"
          :class="[
            isOpen
              ? 'w-5 h-5 text-gray-600 hover:text-gray-900'
              : 'w-6 h-6 text-gray-400 hover:text-white'
          ]"
        />
      </button>
    </transition>

    <transition name="fade">
      <input
        v-if="isOpen"
        class="text-gray-800 flex-grow mx-1 w-full h-auto bg-transparent"
        type="search"
        name="query"
        ref="input"
        placeholder="Search"
        @blur="handleBlur"
        @keyup.esc="handleEscape"
        :value="value"
        @input="$emit('input', $event.target.value)"
        :class="[
          [value.$error ? 'error' : 'noError'],
          [isOpen ? 'show' : 'hide']
        ]"
      />
    </transition>

    <transition name="fade">
      <button
        v-if="value.trim().length > 0"
        @click.stop="handleEscape"
        class="flex"
      >
        <unicon
          name="times"
          class="w-5 h-5 justify-content z-30 hover:text-gray-900"
        />
      </button>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'SearchBox',
  props: {
    value: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isOpen: false
    }
  },
  mounted() {
    if (this.value.trim().length > 0) this.isOpen = true
  },
  methods: {
    searchIconClicked: function() {
      // if closed / open & focus
      // if open & query / don't close & focus
      // if open & no query / close & don't focus

      if (!this.isOpen) {
        // WAS CLOSED
        this.isOpen = true // must do before nextTick for focus to work
        this.$nextTick(() => {
          this.$refs.input.focus()
        })
      } else {
        // WAS OPEN
        if (this.value.trim().length > 0) {
          // HAS SEARCH QUERY
          this.$nextTick(() => this.$refs.input.focus())
        } else {
          // NO SEARCH QUERY
          this.$nextTick(() => {
            this.isOpen = false
          })
        }
      }
    },
    handleBlur: function() {
      if (this.value.trim().length === 0) {
        this.$nextTick(() => {
          this.isOpen = false
        })
      }
    },
    handleEscape: function() {
      this.$nextTick(() => {
        this.$emit('input', '')
        this.isOpen = false
      })
    }
  }
}
</script>

<style>
.searchContainer {
  will-change: width;
  transform: translateZ(0);
  backface-visibility: hidden;
  perspective: 1000px;
  transition: width 0.4s, background-color 0.2s ease-out;
}
</style>
